import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { Community, User } from "../../../../models";

@Component({
  selector: "del-membership-auth-modal",
  templateUrl: "./del-membership-auth-modal.component.html",
  styleUrls: [
    "./del-membership-auth-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DelMembershipAuthModal implements OnInit {
  @Input() currentUser: User;
  @Input() community: Community;
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
